














import { computed, defineComponent, onMounted } from '@vue/composition-api';
import { biBrow } from '@tencent/fit-bi-sdk';
import PastItem from '@/components/past-module/past-item.vue';
import { useStampStore } from '@/store/stamp';

export default defineComponent({
  name: 'past',
  components: {
    PastItem,
  },
  setup() {
    const stampStore = useStampStore();
    const pastList = computed(() => stampStore.pastList);

    onMounted(async () => {
      biBrow('past.page_brow|往期曝光');
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
    return {
      pastList,
    };
  },
});
